import { render, staticRenderFns } from "./CopyScheduleWeekModal.vue?vue&type=template&id=04d3bcfa&"
import script from "./CopyScheduleWeekModal.vue?vue&type=script&lang=js&"
export * from "./CopyScheduleWeekModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports